import { render, staticRenderFns } from "./UnauthorizedMessage.vue?vue&type=template&id=531aacd5&"
import script from "./UnauthorizedMessage.vue?vue&type=script&lang=ts&"
export * from "./UnauthorizedMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports